import { render } from "./Tab.vue?vue&type=template&id=79e7546a&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"

import "./Tab.vue?vue&type=style&index=0&id=79e7546a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-79e7546a"

export default script